import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants";

const MyNavbar = () => (
  <AppBar position="sticky" color="default" elevation={3}>
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <Typography
        variant="h6"
        component={Link}
        to={ROUTES.home}
        sx={{ textDecoration: "none", color: "primary.main", fontWeight: 700 }}
      >
        Craig Lawlor
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          component={Link}
          to={ROUTES.hub}
          color="inherit"
          variant="outlined"
          size="small"
          sx={{ ml: 2 }}
        >
          Admin Hub
        </Button>
      </Box>
    </Toolbar>
  </AppBar>
);

export default MyNavbar;